import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useDataAggregation } from '../../Common/hooks/useAggregationData';
import { useCadUniqueChartsDataContext } from './hooks/useCadUniqueChartsDataContext';
import { getMonthLabel } from '../../../Common/Util/getMonthLabel'

export const FamiliesMonth = () => {
    const { chartData } = useCadUniqueChartsDataContext();

    const rawData = chartData?.familiesMonth || [];

    const series = [
        {
            name: 'Famílias Cadastradas',
            data: chartData?.familiesMonth?.map(item => item.value) || []
        }
    ];

    const isYearComparison = rawData.length > 0 && rawData.every(item => item.mes === rawData[0].mes);
    const formattedSubtitles = isYearComparison ? rawData.map(item => `${getMonthLabel(item.mes)}/${item.ano}`): rawData.map(item => getMonthLabel(item.mes));

    return (
        <SimpleBars
            title={'Evolução mensal das famílias cadastradas'}
            horizontal={false}
            subtitles={formattedSubtitles}
            series={series}
            stacked
        />
    );
};